import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  timeline: {
    padding: 0,
    marginTop: "10px",
    paddingLeft: 0,
    "& .MuiTimelineItem-root": {
      paddingLeft: 0,
      display: "flex",
      alignItems: "stretch",
      minHeight: "auto",
      "&:before": {
        display: "none",
      },
    },
    "& .MuiTimelineSeparator-root": {
      paddingRight: "30px",
      alignSelf: "stretch",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "flex-start",
      position: "relative",
      minHeight: "100%",
    },
    "& .MuiTimelineDot-root": {
      backgroundColor: "#ec6535",
      border: "2px solid #ec6535",
      width: "16px",
      height: "16px",
      margin: 0,
      flexShrink: 0,
    },
    "& .MuiTimelineConnector-root": {
      backgroundColor: "#ec6535",
      width: "2px",
      flex: 1,
      minHeight: "40px",
      position: "relative",
    },
  },
  timelineContent: {
    padding: 0,
    paddingLeft: 0,
    marginBottom: "24px",
    display: "flex",
    alignItems: "center",
    flex: 1,
    width: "100%",
    minWidth: 0,
  },
  lastTimelineContent: {
    marginBottom: "0px",
  },
  firstDot: {
    backgroundColor: "#fff !important",
    border: "2px solid #ec6535 !important",
  },
  firstTimelineContent: {
    marginTop: "20px",
  },
  dashedLine: {
    width: "2px",
    flex: 1,
    minHeight: "60px",
    backgroundImage: "repeating-linear-gradient(to bottom, #ec6535 0px, #ec6535 4px, transparent 4px, transparent 8px)",
  },
}));

